import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
import IconBase, { IconProps } from '../IconBase';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const IconShipping24 = (baseProps: IconProps, ref: Ref<SVGSVGElement>) => {
  return <IconBase {...baseProps}>
        {({
      title,
      titleId,
      ...props
    }: Partial<React.SVGProps<SVGSVGElement>> & SVGRProps) => <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fillRule="evenodd" clipRule="evenodd" d="M13.0002 1.49944L13.3054 1.62538L22.5056 5.42214L23.0004 5.62635V6.16165V6.30963V17.6398V18.1649L22.5187 18.3738L13.3184 22.3625L13.0002 22.5004L12.682 22.3625L3.63406 18.4398H0V16.8398H3.00001V14.8073H4.60001V17.1147L12.2002 20.4097V10.5914L4.60001 7.49885V9.14218H3.00001V6.96165H0V5.36165H3.64142L12.695 1.62538L13.0002 1.49944ZM5.72922 6.23094L13.0002 3.23033L20.2712 6.23094L13.0002 9.18952L5.72922 6.23094ZM13.8002 10.5914V20.4097L21.4004 17.1147V7.49885L13.8002 10.5914ZM7.39098e-06 11.1999H7.03193V12.7999H7.39098e-06V11.1999Z" fill="currentColor" /></svg>}
      </IconBase>;
}; // This explicit type declaration prevents TypeScript from expanding IconProps into a huge Pick type
const ForwardRef: React.ForwardRefExoticComponent<IconProps & React.RefAttributes<SVGSVGElement>> = React.forwardRef<SVGSVGElement, IconProps>((props, ref) => {
  return IconShipping24(props, ref);
});
export default ForwardRef;